<template>
  <div class="modal-container">
    <el-form :rules="rules" ref="ruleFormXX" :model="ruleForm">
      <div class="travel-attr-container">
        <p class="title">你的旅程将会帮助更多的人</p>
        <p class="space-between">
          <span class="input-item">
            <span class="prefix">出发日期</span>
            <span class="input-content">
              <el-form-item label="" prop="beginDate">
                <el-date-picker
                  v-model="beginDate"
                  :prefix-icon="'1'"
                  :editable="false"
                  type="date"
                  value-format="yyyy-MM-dd hh:mm:ss"
                  placeholder="选择日期"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </el-form-item>
            </span>
          </span>
          <span class="input-item">
            <span class="prefix">出游天数</span>
            <span class="input-content input">
              <el-form-item label="" prop="playDays">
                <el-input
                  ref="playDays"
                  v-model="ruleForm.playDays"
                  maxlength="9"
                ></el-input>
              </el-form-item>
            </span>
            <span class="suffix">天</span>
          </span>
          <span class="input-item">
            <span class="prefix">人均消费</span>
            <span class="input-content input">
              <el-form-item label="" prop="price">
                <el-input
                  ref="price"
                  v-model="ruleForm.price"
                  maxlength="9"
                ></el-input>
              </el-form-item>
            </span>
            <span class="suffix">元</span>
          </span>
        </p>
        <p>
          <span class="radio-title">自驾玩法</span>
          <span class="radio-content">
            <span
              class="radio"
              v-for="(item, index) in playWayList"
              :class="checkInPlayWay(item.value) ? 'radio-checked' : ''"
              :key="index"
              @click="checkPlayWay(item)"
              >{{ item.label }}</span
            >
          </span>
        </p>
        <p class="no-margin-bottom">
          <span class="radio-title">和谁去</span>
          <span class="radio-content">
            <span
              class="radio"
              :class="tourPar == item.code ? 'radio-checked' : ''"
              :key="index"
              v-for="(item, index) in partnerList"
              @click="checkPartner(item)"
              >{{ item.label }}</span
            >
          </span>
        </p>
        <p class="no-margin-bottom space-between">
          <span class="input-item">
            <span class="prefix">总里程</span>
            <span class="input-content input large">
              <el-form-item label="" prop="totalMileage">
                <el-input
                  ref="days"
                  v-model="ruleForm.totalMileage"
                  maxlength="9"
                ></el-input>
              </el-form-item>
            </span>
            <span class="suffix">公里</span>
          </span>

          <span class="radio-item">
            <span class="radio-title">驾驶难度</span>
            <span class="radio-content">
              <span
                class="radio"
                v-for="(item, index) in difficultList"
                :class="difficulty == item.code ? 'radio-checked' : ''"
                :key="index"
                @click="checkDifficult(item)"
                >{{ item.label }}</span
              >
            </span>
          </span>
        </p>
        <p class="travel-attr-btn">
          <span class="orange-btn" @click="editContinue">继续编辑</span>
        </p>
      </div>
    </el-form>
    <div class="modal-layer" v-show="modalVisible">
      <div class="modal-panel">
        <span
          class="dash-border-all"
          v-show="!ruleForm.playDays && !ruleForm.price"
        >
          <span>
            <el-input
              @focus="
                modalVisible = false;
                $refs.playDays.focus();
              "
            ></el-input>
          </span>
          <span>
            <el-input
              @focus="
                modalVisible = false;
                $refs.price.focus();
              "
            ></el-input>
          </span>
        </span>
        <span
          class="dash-border-left"
          v-show="!ruleForm.playDays && ruleForm.price"
        >
          <span>
            <el-input
              @focus="
                modalVisible = false;
                $refs.playDays.focus();
              "
            ></el-input>
          </span>
        </span>
        <span
          class="dash-border-right"
          v-show="ruleForm.playDays && !ruleForm.price"
        >
          <span>
            <el-input
              @focus="
                modalVisible = false;
                $refs.price.focus();
              "
            ></el-input>
          </span>
        </span>
        <span
          class="hint-container"
          :class="
            !ruleForm.playDays && !ruleForm.price
              ? 'position-middle'
              : !ruleForm.price
              ? 'position-right'
              : 'position-left'
          "
        >
          <span class="hint-arrows"></span>
          <span class="hint-text">填写会更容易被推荐</span>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import api from "../../axios/api";
import Global from "../../utils/Global";
import service from "../../axios/service/service";
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  watch: {
    "ruleForm.playDays"(newValue, oldVlue) {
      this.playDaysOldValue = oldVlue;
    },
    "ruleForm.totalMileage"(newValue, oldVlue) {
      this.totalMileageOldValue = oldVlue;
    },
    "ruleForm.price"(newValue, oldVlue) {
      this.priceOldValue = oldVlue;
    }
  },
  data() {
    let playDaysValidate = (rule, value, callback) => {
      let reg = /^([1-9][0-9]*$)/;
      //由于在气泡处校验了，则此处为空就让其校验通过
      if (value === "") {
        callback();
      } else {
        if (!reg.test(value)) {
          this.ruleForm.playDays = this.playDaysOldValue;
          callback();
        }
      }
    };
    // 勿删，改版的时候会用
    let totalMileageValidate = (rule, value, callback) => {
      //整数或者小数点保留后一位
      let reg = /^(\d+)(\.?\d{0,1})?$/;
      if (value === "") {
        callback();
      } else {
        if (!reg.test(value)) {
          this.ruleForm.totalMileage = this.totalMileageOldValue;
          callback();
        }
      }
    };
    // 勿删，改版的时候会用
    let totalMileageValidateEnd = (rule, value, callback) => {
      //如果以"."结尾则删除点
      if (value.indexOf(".") === value.length - 1) {
        this.ruleForm.totalMileage = value.slice(0, value.length - 1);
        callback();
      }
    };
    let totalMileageValidateInt = (rule, value, callback) => {
      let reg = /^([1-9][0-9]*$)/;
      //由于在气泡处校验了，则此处为空就让其校验通过
      if (value === "") {
        callback();
      } else {
        if (!reg.test(value)) {
          this.ruleForm.totalMileage = this.totalMileageOldValue;
          callback();
        }
      }
    };
    let priceValidate = (rule, value, callback) => {
      let reg = /^([1-9][0-9]*$)/;
      //由于在气泡处校验了，则此处为空就让其校验通过
      if (value === "") {
        callback();
      } else {
        if (!reg.test(value)) {
          this.ruleForm.price = this.priceOldValue;
          callback();
        }
      }
    };
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      priceOldValue: "",
      playDaysOldValue: "",
      totalMileageOldValue: "",
      partnerList: [
        { code: 1, label: "独自一人" },
        { code: 2, label: "好友" },
        { code: 3, label: "亲子" },
        { code: 4, label: "情侣" },
        { code: 5, label: "闺蜜" },
        { code: 6, label: "同学" },
        { code: 7, label: "拼团" },
        { code: 8, label: "家人" }
      ],
      difficultList: [
        { code: 1, label: "轻松" },
        { code: 2, label: "适中" },
        { code: 3, label: "困难" }
      ],
      modalVisible: false,
      playTypeIdList: [],
      playWaydata: "",
      tourPar: "",
      difficulty: "",
      beginDate: "",
      ruleForm: {
        playDays: "",
        price: "",
        totalMileage: ""
      },
      rules: {
        playDays: [{ validator: playDaysValidate, trigger: "change" }],
        price: [{ validator: priceValidate, trigger: "change" }],
        totalMileage: [
          { validator: totalMileageValidateInt, trigger: "change" }
          /* { validator: totalMileageValidate, trigger: "change" },
          { validator: totalMileageValidateEnd, trigger: "blur" } */
        ]
      }
    };
  },
  created() {
    this.getDataTypeList({ type: 4 });
  },
  computed: {
    ...mapState("WriteDataStore", ["playWayList"]) //自驾玩法
  },
  methods: {
    ...mapActions("WriteDataStore", ["getDataTypeList"]), //自驾玩法
    ...mapMutations("WriteDataStore", ["travelAttributeData"]), //保存编辑数据
    checkPlayWay(playWayNode) {
      this.playWaydata = playWayNode.value;
      //首先看再不在数组中，如果在则删除，如果不在则加入
      let resultIndex = this.playTypeIdList.findIndex((value, index, arr) => {
        return value.typeId === this.playWaydata;
      });
      if (resultIndex === -1) {
        if (this.playTypeIdList.length === 3) {
          Global.messageErr("最多选择3项!");
          return;
        } else {
          this.playTypeIdList.push({ typeId: this.playWaydata });
        }
      } else {
        // 如果在数组中则删除
        this.playTypeIdList.splice(resultIndex, 1);
      }
    },
    checkInPlayWay(value) {
      let result = this.playTypeIdList.some(item => {
        return item.typeId === value;
      });
      return result;
    },
    checkDifficult(difficultNode) {
      this.difficulty = difficultNode.code;
    },
    checkPartner(partnerNode) {
      this.tourPar = partnerNode.code;
    },
    validate() {
      return this.ruleForm.playDays && this.ruleForm.price;
    },
    editContinue() {
      if (!this.validate()) {
        this.modalVisible = true;
      } else {
        this.travelAttributeData({
          beginDate: this.beginDate,
          playTypeIdList: this.playTypeIdList,
          tourPar: this.tourPar,
          playDays: this.ruleForm.playDays,
          price: this.ruleForm.price,
          totalMileage: this.ruleForm.totalMileage,
          difficulty: this.difficulty
        });
        this.$router.push({ path: `/traveling/new` }).catch(e => {});
      }
    }
  }
};
</script>
<style lang="less">
@import "~@/lesses/main/travel/travel-attribute.less";
.modal-container {
  .el-form-item {
    margin-bottom: 0px;
  }
}
</style>
